import { Modal, Avatar, Button, TextField, BlockStack, InlineStack, Text, Card, Grid, Bleed, Divider, Checkbox, Banner, Badge, Box, Icon, Tooltip } from '@shopify/polaris'
import React, { useCallback, useEffect, useState } from 'react'
import { countryWithDemonym, getCountryFlag } from '../../..';
import { syncConnectorInfo, syncNecessaryInfo } from '../../../../../Actions';
import { DI, DIProps } from '../../../../../Core';
import { DotIcon, UserIcon } from '../../svg/Svgs';
import { getAmazonRegion } from '../../../ProductLinkingsNew/components/utils/utils';
import { EditMinor } from '@shopify/polaris-icons';
import { useTranslation } from 'react-i18next';
import { io, Socket } from 'socket.io-client';
import { DefaultEventsMap } from 'socket.io/dist/typed-events';
import { isAdminLoggedIn } from '../../../../Panel/Panel/index';

interface Props extends DIProps {
  syncNecessaryInfo: () => void;
  syncConnectorInfo: (props: any, shop_url?: string | null) => void;
}

interface ModalStateI { open: boolean, id: string, name: string, accounts: number }

function Accounts(Props: Props) {
  const { t } = useTranslation();
  const [accountEditFlag, setaccountEditFlag] = useState({ open: false, id: '', name: '' });
  const [disconnectAccountModal, setdisconnectAccountMOdal] = useState({ open: false, id: '', name: '', accounts: 0 })
  const [confirmReauth, setConfirmReauth] = useState(false)

  const setAccountEditModal = useCallback((a: ModalStateI) => {
    setaccountEditFlag(a)
  }, [accountEditFlag])

  const setDisconnectAccountModal = useCallback((a: ModalStateI) => {
    setdisconnectAccountMOdal(a)
  }, [disconnectAccountModal])

  const getCurrentConnectedAccount = () => {
    return Props?.redux?.current?.target?.["_id"]

  }

  const getCountryName = (id: string) => {
    return (countryWithDemonym?.[id]?.['country_name'])
  }

  const getTokenRenewalTime = (account: any) => {
    let time: any = '';
    let myDate: any = '';
    if (account?.renewal_time) {
      myDate = new Date(account.renewal_time);
    }
    else if (account?.updated_at) {
      myDate = new Date(+account?.updated_at?.['$date']?.['$numberLong'])
    }
    else {
      myDate = new Date(+account?.created_at?.['$date']?.['$numberLong']);
    }
    time = myDate.toGMTString();
    return time
  }


  //THIS FUNCTION WILL RENDER ACCOUNT COMPONENT
  const RenderAccount = (props: any) => {
    const [currentConnected, setcurrentConnected] = useState(getCurrentConnectedAccount())

    let account1: any = []

    // NEED TO REFACTOR THIS CODE BEFORE PRODUCTION @ASHISHKUMARKASHYAP
    if (Props?.redux?.account?.target['amazon'] != undefined && Props?.redux?.account?.target['amazon'].length > 0) {
      Props?.redux?.account?.target['amazon'].map((account: any, index: number) => {
        if (currentConnected == account?.["_id"]) {
          account1.unshift(account)
        }
      })
      Props?.redux?.account?.target['amazon'].map((account: any, index: number) => {
        if (currentConnected != account._id) {
          account1.push(account)
        }

      })
    }

    const getMarketplaceUrl = (marketplace_id: string, amazon_seller_id: string) => {
      const amazonRegion: any = getAmazonRegion(marketplace_id, "marketplace_id");
      const url: string = amazonRegion?.seller_profile_url + `?seller=${amazon_seller_id}`;
      return url
    }

    let redertac = account1.map((account: any, index: number) => {

      return (
        <React.Fragment key={index}>

          <InlineStack align="space-between">
            <InlineStack gap={"400"}>
              <div><Avatar customer name="Farrah" size="sm" source={getCountryFlag(Props, account?.["_id"])} /></div>
              <InlineStack gap="400">
                <BlockStack gap={"100"}>
                  <InlineStack gap={"500"} align='start'>
                    <InlineStack>
                      <InlineStack gap="025" >
                        {/* {currentConnected == account?.["_id"] && <DotIcon />} */}
                        <Text as="h6" variant="bodyMd" fontWeight="bold">{account?.sellerName || "N/A"}</Text>
                      </InlineStack>
                      <InlineStack blockAlign='start'>
                        <Text as="h6" variant="bodyMd" fontWeight="bold"> <span className='ml-4'> ( {t("Amazon ID:")}</span>  <Button url={getMarketplaceUrl(account?.warehouses?.[0]?.marketplace_id, account?.warehouses?.[0]?.seller_id)} variant='plain' external target='_blank'>{account?.warehouses?.[0]?.seller_id}</Button> )</Text>
                      </InlineStack>
                    </InlineStack>
                    <Tooltip content="Edit Store Name">
                      <span className='c-pointer' onClick={() => { setAccountEditModal({ open: true, id: account['_id'], name: account?.sellerName ?? '', accounts: account1?.length ?? 0 }) }}>
                        <Icon source={EditMinor} />
                      </span>
                      {/* <Button icon={EditMinor}  id={`accounts_Btn_${account?.warehouses?.[0]?.seller_id}_EditStoreName`}>
                      </Button> */}
                    </Tooltip>
                  </InlineStack>
                  <Text as="p" variant='headingSm' tone={currentConnected == account?.["_id"] ? 'success' : 'subdued'}>{currentConnected == account?.["_id"] ? t("Active Account") : "Account connected"}</Text>

                  <Text variant="bodyMd" as="h6" id={`accounts_Text_${getCountryName(account?.warehouses?.[0]?.marketplace_id)}`}>
                    {getCountryName(account?.warehouses?.[0]?.marketplace_id)}
                  </Text>
                  <InlineStack gap={'200'}>
                    <div className='Custom__Sync--Update renewal-token'>
                      <Text as="p" tone="subdued" id={`accounts_Text_${getCountryName(account?.warehouses?.[0]?.marketplace_id)}`} variant='bodyMd' fontWeight='regular'>
                        {t("Token renewal time:")} {getTokenRenewalTime(account)}
                      </Text>
                    </div>
                    <Button onClick={() => props.setConfirmReauth(!props.confirmReauth)} variant='plain'>
                      {t("Refresh Access Token")}
                    </Button>
                  </InlineStack>
                </BlockStack>
              </InlineStack>
            </InlineStack>
            <div><Button onClick={() => setDisconnectAccountModal({ open: true, id: account['_id'], name: account?.sellerName ?? '', accounts: account1?.length ?? 0 })} id={`accounts_Btn_${account?.warehouses?.[0]?.seller_id}_Disconnect`}>{t("Disconnect")}</Button></div>
          </InlineStack>
          {index < account1.length - 1 && <Bleed marginInline="500"><Divider /></Bleed>}
        </React.Fragment>
      );
    })
    return (<>
      {redertac.map((account: any) => { return account })}
    </>)
  }

  return (
    <BlockStack gap="500">
      <InlineStack align='space-between' gap="200">
        <Text variant="headingMd" as="h6" id={`accounts_Text_connectedAccounts`}>
          {t("Connected Accounts")}
        </Text>
        <Tooltip content={t("Add New Account")}>
          <Button
            onClick={() => { Props.history('../../newAccount') }}
            id='accounts_Btn_addNewAccount'
            variant="primary" size='micro'>{t("Connect")}</Button>
        </Tooltip>
      </InlineStack>
      <Card padding="400" roundedAbove='sm'>
        <BlockStack gap="400">
          <RenderAccount {...Props} confirmReauth={confirmReauth} setConfirmReauth={setConfirmReauth} />
        </BlockStack>
        {disconnectAccountModal && <RenderDisconnectModal disconnectAccountModal={disconnectAccountModal} setDisconnectAccountModal={setDisconnectAccountModal} />}
        <RenderAccountNameEditModal t={t} accountEditFlag={accountEditFlag} setaccountEditFlag={setAccountEditModal} />

        <RenderReauthConfirmationModal {...Props} t={t} confirmReauth={confirmReauth} setConfirmReauth={setConfirmReauth} ></RenderReauthConfirmationModal>
      </Card>
    </BlockStack>
  )
}

export default DI(Accounts, { func: { syncConnectorInfo, syncNecessaryInfo } });

interface AccountEditI extends DIProps {
  accountEditFlag: ModalStateI;
  setaccountEditFlag: (a: ModalStateI) => void;
  syncNecessaryInfo: () => void;
  syncConnectorInfo: (props: any, shop_url?: string | null) => void;
  t: any
}
//THIS FUNCTIONS RENDERS EDIT ACCOUNT MODAL
export const RenderAccountNameEditModal = DI((Props: AccountEditI) => {
  const { accountEditFlag, setaccountEditFlag, t } = Props
  const [value, setvalue] = useState<string>(accountEditFlag.name)
  const [loading, setloading] = useState<boolean>(false)
  const [Error, setError] = useState('')
  const [disabled, setdisabled] = useState<boolean>(false)
  const handleChange = () => setaccountEditFlag({ open: !accountEditFlag.open, id: '', name: '', accounts: 0 });

  useEffect(() => {
    value.trim() != "" && !(value.length > 32) ? setdisabled(false) : setdisabled(true)
  }, [value])

  useEffect(() => {
    setvalue(accountEditFlag.name)
  }, [accountEditFlag.name])

  const ChangeAccountName = () => {

    if (value.trim() != "") {
      setloading(true)
      Props.di.POST("connector/config/updateShopName", { sellerName: value }, false, { 'Ced-Target-Id': accountEditFlag.id }).then((response) => {


        if (response.success) {

          const shop = Props.di.globalState.get(
            `shop`
          );
          Props.syncConnectorInfo(Props, shop);
          setloading(false)
          setaccountEditFlag({ open: false, id: '', name: '', accounts: 0 })

          Props.success(t(response.message));

        } else {
          setloading(false)
          setaccountEditFlag({ open: false, id: '', name: '', accounts: 0 })
          Props.error(t(response.message))
        }
      })

    } else {
      setError(t("Please provide shop name"))
      setvalue("")
    }

  }

  return (
    <Modal
      open={accountEditFlag.open}
      onClose={handleChange}
      title={t("Shop name")}
      primaryAction={{
        id: 'accounts_Btn_Save',
        content: t("Save"),
        onAction: ChangeAccountName,
        loading: loading,
        disabled: disabled
      }}
      secondaryActions={[
        {
          id: 'accounts_Btn_Cancel_EditStoreName',
          content: t("Cancel"),
          onAction: handleChange,
        },
      ]}
    >
      <Modal.Section>
        <TextField
          id='accounts_TextField_EditShopName'
          label={t("New shop name")}
          value={value}
          placeholder={t("Enter new shop name")}
          onChange={(name: string) => {

            setvalue(name);
            name.length > 32 ? setError(t('Shop Name cannot exceed more than 32 characters.')) : setError('')

          }}
          error={Error}
          maxLength={32}
          autoComplete="off"
          showCharacterCount
        />
      </Modal.Section>
    </Modal>

  )

}, { func: { syncConnectorInfo, syncNecessaryInfo } })




export const RenderReauthConfirmationModal = DI((props: any) => {

  const { confirmReauth, setConfirmReauth, t } = props

  function getConnectedSources(socket: any) {
    let id = props.di.globalState.get('remote_shop_id')
    socket.disconnect()
    if (!id || id === '') return;
    props.di.POST("amazon/request/getConnectedSource", { "remote_shop_id": id }).then((data: any) => {
      if (data?.success && Array.isArray(data?.data))
        props.di.globalState.set('connected_sources', JSON.stringify(data.data))
      else
        props.error(t(data?.message) ?? t("Couldn't find connected sources"))
    })
  }

  function connectAmazon(socket: any = '') {
    let state = { "app_tag": props.di.environment.appTag, "user_id": props.di.user_id, "source": "shopify", "source_shop_id": props?.redux?.current?.source?.['_id'] ?? '', "redirect_return_type": "message" }
    let url = `${props.di.environment.API_ENDPOINT}connector/get/installationForm?code=${'amazon'}&region=${props?.redux?.current?.target?.warehouses?.[0]?.region}&version=new&sandbox=1&marketplace_id=${props?.redux?.current?.target?.warehouses?.[0]?.marketplace_id}&state=${JSON.stringify(state)}&bearer=${props.di.globalState.getBearerToken()}`;
    let test = window.open(url + '&redirect_return_type=message', 'popUpWindow', 'height=500,width=800,left=100,top=100,resizable=yes,scrollbars=yes,toolbar=yes,menubar=no,location=no,directories=no, status=yes');

    if (test) {
      const int = setInterval(() => {
        if (test?.closed) {
          getConnectedSources(socket)
          setConfirmReauth(false)
          const shop = props.di.globalState.get(`shop`);
          props.syncConnectorInfo(props, shop, false, false);
          props.syncNecessaryInfo({ connectAmazon: true, onboardingProps: props, source_shop_id: props?.redux?.current?.source?.['_id'] ?? '', target_shop_id: props?.redux?.current?.target?.['_id'] ?? "" });
          clearInterval(int);
        }
      }, 1000);
    }
    else {
      url = url + '&redirect_return_type=app';
    }
    // if no
    // then open modal and add anhor tag <a/>
  }


  const tokenExpirationReAuth = () => {
    props.di.globalState.removeLocalStorage('remote_shop_id')
    let socket = io('https://amazon.websocket.cedcommerce.com/', { path: '/onboarding.live', transports: ["websocket", "polling"] });;
    socket.on('connect', () => {
      socket.emit("set_room", props.di.user_id + props?.redux?.current?.source?.['_id']);
      socket.on('getRemoteShopID', (data: string) => {
        props.di.globalState.set('remote_shop_id', data, true)
      });
    })
    socket.on('disconnect', () => { })
    connectAmazon(socket);
    // props.di.globalState.set('account_checklist', JSON.stringify(states?.['accont_connection_list']), true);
  }






  return (
    <Modal
      open={confirmReauth}
      onClose={() => setConfirmReauth(!confirmReauth)}
      title={t("Re-Auth confirmation")}
      primaryAction={{
        id: 'accounts_Btn_Save',
        content: t("Confirm"),
        onAction: tokenExpirationReAuth,
      }}
      secondaryActions={[
        {
          id: 'accounts_Btn_Cancel_EditStoreName',
          content: t("Cancel"),
          onAction: () => setConfirmReauth(false),
        },
      ]}
    >
      <Modal.Section>
        <Text as='p'> {t("Are you sure you want to proceed for Re-Auth?")}</Text>
      </Modal.Section>
    </Modal>

  )

}, { func: { syncConnectorInfo, syncNecessaryInfo } })

interface DisconnectAccountI extends DIProps {
  disconnectAccountModal: ModalStateI;
  setDisconnectAccountModal: (a: ModalStateI) => void;
  syncNecessaryInfo: () => void;
  syncConnectorInfo: (props: any, shop_url?: string | null) => void;
}
//THIS FUNCTION IS RENDERING DISCONNECT ACCOUNT MODAL
export const RenderDisconnectModal = DI((Props: DisconnectAccountI) => {
  const { t } = useTranslation();
  const { disconnectAccountModal, setDisconnectAccountModal } = Props
  const [modalButtonLoading, setmodalButtonLoading] = useState<boolean>(false)
  const [value, setValue] = useState("");
  const [disconnectDisable, setdisconnectDisable] = useState(true);
  const [deletionInProgress, setDeletionInProgress] = useState<boolean>(false);


  const handleChangeText = useCallback((newValue: string) => setValue(newValue), []);
  const handleChange = () => { setDisconnectAccountModal({ open: !disconnectAccountModal.open, id: '', name: '', accounts: 0 }); setDeletionInProgress(false) };
  useEffect(() => {

    if (value === "confirm") {
      setdisconnectDisable(false)
    } else {
      setdisconnectDisable(true)
    }
  }, [value])

  useEffect(() => {
    setValue('')
  }, [Props.disconnectAccountModal])

  //FUNCTION FOR DICONNECT ACCOUNT
  const DisconnectAccount = () => {
    setmodalButtonLoading(true);
    let data: any = {
      "target": {
        "marketplace": "amazon",
        "shopId": disconnectAccountModal.id
      },
      "source": {
        "marketplace": "shopify",
        "shopId": Props?.redux?.current?.source?._id
      },
      "disconnected": {
        "target": 1
      }

    }
    if (deletionInProgress) {
      data['deletion_in_progress'] = deletionInProgress;
    }
    Props.di.POST("connector/request/updatedDisconnectAccount", data, false, { 'Ced-Target-Id': disconnectAccountModal.id }).then((response) => {
      setmodalButtonLoading(false)
      setDisconnectAccountModal({ open: !disconnectAccountModal.open, id: '', name: '', accounts: 0 })
      if (response.success) {
        const shop = Props.di.globalState.get(
          `shop`
        );
        syncNecessaryInfo()
        Props.di.globalState.removeLocalStorage(
          `target_id`
        );
        Props.di.globalState.removeLocalStorage(
          `source_id`
        );
        Props.di.globalState.removeLocalStorage('onboarding_completed');
        Props.success(t(response.message))
      } else {
        Props.error(t(response.message))
      }
      setDeletionInProgress(false);
    })
  }


  return (
    <Modal
      open={disconnectAccountModal.open}
      onClose={handleChange}
      title={t("Disconnect Account")}
      primaryAction={{
        id: 'accounts_Btn_Disconnect',
        content: t("Disconnect"),
        destructive: true,
        onAction: DisconnectAccount,
        disabled: disconnectDisable,
        loading: modalButtonLoading
      }}
      secondaryActions={[
        {
          id: 'accounts_Btn_Cancel_Disconnect',
          content: t("Cancel"),
          onAction: handleChange,
        },
      ]}
    >
      <Modal.Section>
        <BlockStack gap="200">
          <Text as='p'>{t(`   Are you sure you want to disconnect`)} {disconnectAccountModal.name} {t(`account ?`)}</Text>
          <Text as='p'>{t("To confirm, enter the phrase")} <strong>confirm</strong></Text>
          {disconnectAccountModal?.accounts == 1 ?
            <Banner tone='info'><Text as='p'><strong>{t("Note")} : </strong>{t("All data pertaining to product listings, settings, templates, and product linkages will be permanently deleted within 48 hours upon confirmation.")}</Text></Banner> : <></>
          }
          <TextField
            id='accounts_TextField_Confirm'
            placeholder={t('confirm')}
            label={undefined}
            value={value}
            onChange={handleChangeText}
            autoComplete="off"
          />
          {(isAdminLoggedIn()
            || process.env.REACT_APP_PROD === '0'
          ) && <Checkbox
              label={t("Check this box if you plan to reconnect this Amazon account with another Shopify store having CedCommerce Amazon Channel installed. This will expedite the account disconnect process.")}
              checked={deletionInProgress}
              onChange={(e) => setDeletionInProgress(e)}
            />}
        </BlockStack>
      </Modal.Section>
    </Modal>
  );
}, { func: { syncConnectorInfo, syncNecessaryInfo } })